import type { PhoneIssueVerdict } from '~/types/PhoneIssueVerdict'
import { resolvePhoneMessage } from './resolvePhoneMessage'
import type { TranslateFn } from './TranslateFn'

/** The phone message for an issue that is a phone rule; otherwise the caller's own fallback message. */
export function resolvePhoneMessageOr(
  t: TranslateFn,
  issueVerdict: PhoneIssueVerdict,
  fallback: () => string
): string {
  return issueVerdict.isPhoneIssue ? resolvePhoneMessage(t, issueVerdict.verdict) : fallback()
}
